import { useCreateMachine } from 'fsm';
import { useCurrentUser } from 'policy-lib';
import { machine } from './machine';
import { EnrichmentPropertiesContext } from './context';
import { useCRMUpdateObject } from '../useCRMUpdateObject';
import { useEnrichmentPolicy } from '../../EnrichmentPolicy/useEnrichmentPolicy';
import { usePanelAlerts } from '../../Panel/usePanelAlerts';
import { jsx as _jsx } from "react/jsx-runtime";
export const EnrichmentPropertiesContextProvider = ({
  children,
  objectId,
  onClose,
  objectTypeId
}) => {
  const currentUser = useCurrentUser();
  const {
    policy: enrichmentPolicy
  } = useEnrichmentPolicy();
  const {
    sendUpdateObjectMessage
  } = useCRMUpdateObject({
    objectId,
    objectTypeId: objectTypeId
  });
  const {
    onError,
    onErrorPropertiesAccess,
    onSuccessProperties
  } = usePanelAlerts({
    objectTypeId: objectTypeId
  });
  const initialContext = {
    currentUser,
    enrichmentPolicy,
    enrichAssociatedRecords: false,
    enrichmentType: 'company',
    isAutoEnrichmentNudgeOpen: enrichmentPolicy.viewAutoSettingsNudge(),
    objectId,
    objectTypeId: objectTypeId,
    onError,
    onErrorPropertiesAccess,
    onSuccess: onSuccessProperties,
    onClose,
    properties: [],
    propertyDefinitions: {},
    propertySources: {},
    propertyUpdates: {},
    sendUpdateObjectMessage,
    selectedProperties: []
  };
  const enrichmentPropertiesMachine = useCreateMachine(machine, {
    initialContext,
    isReady: currentUser.isLoaded && enrichmentPolicy.isLoaded
  });
  return /*#__PURE__*/_jsx(EnrichmentPropertiesContext.Provider, {
    value: enrichmentPropertiesMachine,
    children: children
  });
};